export const toShortLang = (lang: string): string => {
  const availableLanguages = { de: 'de', fr: 'fr', it: 'it', en: 'en' };
  const shortenedInput = lang.substring(0, 2);
  return availableLanguages[shortenedInput] || availableLanguages.de;
};
